import _ from 'underscore';

import mapProps from 'js/lib/mapProps';
import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import user from 'js/lib/user';
import waitFor from 'js/lib/waitFor';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import DiscussionPrompt from 'bundles/discussions/components/discussionPrompt/DiscussionPrompt';
import { naptimeForumTypes } from 'bundles/discussions/constants';
import Naptime from 'bundles/naptimejs';
import DiscussionPromptQuestionsV1 from 'bundles/naptimejs/resources/onDemandDiscussionPromptQuestions.v1';
import OnDemandDiscussionPromptsV1 from 'bundles/naptimejs/resources/onDemandDiscussionPrompts.v1';

const withDiscussionPrompt = _.compose(
  Naptime.createContainer<{ prompt: any }, { itemMetadata: any }>(({ itemMetadata }) => {
    const itemId = itemMetadata.getId();
    const courseId = itemMetadata.get('course').get('id');

    return {
      prompt: OnDemandDiscussionPromptsV1.get(tupleToStringKey([user.get().id, courseId, itemId]), {
        includes: OnDemandDiscussionPromptsV1.DEFAULT_INCLUDES,
        fields: OnDemandDiscussionPromptsV1.DEFAULT_FIELDS,
      }),
    };
  }),
  Naptime.createContainer<{}, { prompt: any }>(({ prompt }) => {
    if (!prompt || !prompt.promptType) {
      return {};
    }

    const { courseItemForumQuestionId } = prompt.promptType.definition;
    const userCourseItemForumQuestionId = [prompt.userId, courseItemForumQuestionId].join('~');

    return {
      discussionPromptQuestion: DiscussionPromptQuestionsV1.localGet(userCourseItemForumQuestionId, {
        fields: DiscussionPromptQuestionsV1.DEFAULT_FIELDS,
      }),
    };
  }),
  waitFor(({ discussionPromptQuestion }) => {
    return !!discussionPromptQuestion;
  }),
  mapProps<{}, { discussionPromptQuestion: any }>(({ discussionPromptQuestion }) => {
    const questionId = discussionPromptQuestion && discussionPromptQuestion.id.split('~')[3];

    const question: {
      id: string;
      questionId: string;
      type: string;
      forumType: string;
    } = {
      id: questionId,
      questionId,
      type: 'question',
      forumType: naptimeForumTypes.rootForumType,
    };

    return {
      isLoaded: true,
      questionId,
      question,
      promptContent: discussionPromptQuestion && discussionPromptQuestion.content.details,
      learnerCount: discussionPromptQuestion && discussionPromptQuestion.totalAnswerCount,
    };
  })
)(DiscussionPrompt);

export default withDiscussionPrompt;
